import { vec3 } from "gl-matrix";
import { Vertex, Face } from "./geometry";

export class VertexNet {

    public grid: GridTile[][];
    public vertices: Vertex[][];
    public allVertices: Vertex[];
    public faces: Face[];

    constructor(public width: number, public height: number, public size: number) {

    }

    public generate(offsetWidth: number, offsetHeight: number, vertexHandler?: (v: Vertex, nx: number, ny: number) => void) {

        // https://www.redblobgames.com/maps/terrain-from-noise/

        let vertices: Vertex[][] = [];
        let allVertices: Vertex[] = [];
        let grid: GridTile[][] = [];

        // Generate the vertices
        for (let x = 0; x < this.width + 1; x++) {
            vertices.push([]);
            grid.push([]);
            for (let y = 0; y < this.width + 1; y++) {
                let vertex = new Vertex();

                let vx = x * this.size + offsetWidth * this.size;
                let vy = y * this.size + offsetHeight * this.size;

                vertex.setPosition(vec3.fromValues(vx, vy, 0));
                vertices[x].push(vertex);

                grid[x].push({
                    id: `${x},${y}`,
                    x: x,
                    y: y,
                    vertex: vertex,
                    faces: []
                });

                allVertices.push(vertex);

                if (vertexHandler) {
                    vertexHandler(vertex, x / this.width, y / this.height);
                }
            }
        }

        // Generate the faces (two triangles)
        let faces: Face[] = [];
        for (let x = 0; x < this.width; x++) {

            for (let y = 0; y < this.width; y++) {
                let faceA = new Face();
                let faceB = new Face();

                faceA.setVertices(vertices[x][y], vertices[x + 1][y], vertices[x][y + 1]);
                faceB.setVertices(vertices[x + 1][y], vertices[x + 1][y + 1], vertices[x][y + 1]);

                faces.push(faceA, faceB);

                grid[x][y].faces.push(faceA, faceB);
            }
        }

        this.grid = grid;
        this.faces = faces;
        this.vertices = vertices;
        this.allVertices = allVertices;

        this.calculateNormals();
    }

    public calculateNormals() {
        this.faces.forEach(face => face.calculateNormal());
        this.allVertices.forEach(vertex => vertex.calculateNormal());
    }

    public addHill(x: number, y: number, range: number, height: number) {
        let vertexList = this.vertices[x][y].getAdjacentVertices(range);
        let distFactor = range * 3;

        for (let vertexData of vertexList) {
            var newHeightFactor = (distFactor - vertexData.distance) / distFactor;
            vertexData.vertex.position[2] += height * newHeightFactor;
        }
    }

    public flatten(x, y, range, z) {
        let vertexList = this.vertices[x][y].getAdjacentVertices(range);

        for (let vertexData of vertexList) {
            vertexData.vertex.position[2] = z;
        }
    }
}

export type GridTile = {
    id: string,
    vertex: Vertex,
    faces: Face[],
    x: number,
    y: number
}
